export default __webpack_public_path__ + "static/media/cropped.916ac172.png";